import type { CSSProperties, ElementType, ReactNode } from 'react';
import { Card } from './Card';

export type PanelProps = {
  title: ReactNode;
  /** Ação à direita do título (link "Ver todas", select, "+ Nova"). */
  action?: ReactNode;
  /** `panel` = painel com conteúdo; `recent` = painel com tabela. */
  variant?: 'panel' | 'recent';
  /**
   * `bar` = título na barra `.panel-head` (padrão quando há ação);
   * `plain` = só o `h2` com respiro embaixo (ex.: "Resumo do período").
   */
  head?: 'bar' | 'plain';
  as?: ElementType;
  className?: string;
  style?: CSSProperties;
  children?: ReactNode;
};

/** Card com cabeçalho (título + ação). */
export function Panel({ title, action, variant = 'panel', head = action ? 'bar' : 'plain', as, className, style, children }: PanelProps) {
  return (
    <Card as={as} padding={variant} className={className} style={style}>
      {head === 'bar' ? (
        <div className="panel-head"><h2>{title}</h2>{action}</div>
      ) : (
        <h2 style={{ marginBottom: 12 }}>{title}</h2>
      )}
      {children}
    </Card>
  );
}
